import { get, put } from '@api/request';

export async function getConferencingConfiguration(
  { conferenceService },
  authenticationToken,
) {
  const url = `${conferenceService}/conference/configuration`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateConferencingConfiguration(
  { conferenceService },
  authenticationToken,
  { payload },
) {
  const url = `${conferenceService}/conference/configuration`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}
